import Vue from 'vue'
import Vuex from 'vuex'

import returnShopPortal from './modules/return-shop-portal'
import texts from './modules/texts'
import config from './modules/config'

Vue.use(Vuex)

const state = {
  title: '',
  sidebar: [],
  breadcrumbs: [],
  tokens: {},
  user: {},
  customer: {},
  menu_visible: false,
  currentUrl:'',
  authConfig: {
    Auth: {
      identityPoolId: profileConfig.auth.identityPoolId,
      region: profileConfig.auth.region,
      userPoolId: profileConfig.auth.userPoolId,
      userPoolWebClientId: profileConfig.auth.userPoolWebClientId,
      oauth: {
        domain: profileConfig.auth.cognitoDomain,
        scope: ['email', 'profile', 'openid'],
        redirectSignIn: profileConfig.auth.redirectSignIn,
        redirectSignOut: profileConfig.auth.redirectSignIn,
        responseType: 'token'
      }
    }
  }
}

const mutations = {
  SET_TITLE (state, title) {
    state.title = title
  },

  SET_TOKENS (state, tokens) {
    state.tokens = tokens
  },

  SET_SIDEBAR (state, sidebar) {
    state.sidebar = sidebar
  },

  SET_BREADCRUMBS (state, breadcrumbs) {
    state.breadcrumbs = breadcrumbs
  },

  SET_USER (state, user) {
    state.user = user
  },

  SET_CUSTOMER (state, customer) {
    state.customer = customer
  },

  SHOW_MENU (state, menu_visible) {
    state.menu_visible = menu_visible
  }
}

const actions = {

}

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  modules: {
    returnShopPortal,
    texts,
    config
  }
})

export default store



// WEBPACK FOOTER //
// ./client/store/index.js